import styled from 'styled-components'
import * as plume from '@ulule/owl-kit-components/next'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  margin: 16px 10px 32px;

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    gap: 24px;
    margin: 32px auto 0;
  }
`
